import React, { useContext } from 'react';
import { UserContext, MetadataContext } from '@/components';
import GalleryButton from '@/components/report/tools/GalleryButton';
import DownloadHubButton from '@/components/report/tools/DownloadHubButton';
import { useDownloadHub } from '@/components';
import { ImageModel, ScrapbookContentType } from '@/types';
import { SaveToScrapbookButton } from '@/components/scrapbook';

type ArticleToolsModel = {
  title?: string;
  pageUrl?: string;
  thumbnailImage?: ImageModel;
  stub?: boolean;
  directory?: string;
  readTime?: string;
  publishedDate?: Date;
  hideGalleryButton?: boolean;
  hideDownloadHubButton?: boolean;
  hideSaveToScrapbookButton?: boolean;
};

const ArticleTools = ({
  title,
  pageUrl,
  thumbnailImage,
  stub,
  directory,
  readTime,
  publishedDate,
  hideGalleryButton,
  hideDownloadHubButton,
  hideSaveToScrapbookButton,
}: ArticleToolsModel) => {
  const user = useContext(UserContext);
  const { pageType, pageId, isPublicReport, isPublicReportIsGated } = useContext(MetadataContext);
  const { downloadHub: downloadHubContextData } = useDownloadHub();

  if (
    !(pageType === 'reportPage' || pageType === 'legacyReportPage') ||
    stub ||
    (isPublicReport && isPublicReportIsGated) ||
    (!isPublicReport && !user?.isAuthenticated && !user?.isIpBasedIdentity) ||
    (hideGalleryButton && hideDownloadHubButton && hideSaveToScrapbookButton)
  ) {
    return null;
  }

  return (
    <>
      <div className="flex gap-2 print:hidden">
        {!hideGalleryButton && <GalleryButton className="btn btn-from-bg icon transparent" />}
        {!hideDownloadHubButton &&
          (user?.isAuthenticated || user?.isIpBasedIdentity || (isPublicReport && !isPublicReportIsGated)) && (
            <DownloadHubButton data={downloadHubContextData} className="btn btn-from-bg icon transparent" />
          )}

        {!hideSaveToScrapbookButton && (user?.isAuthenticated || user?.isIpBasedIdentity) && (
          <SaveToScrapbookButton
            scrapbookContent={{
              pageId: pageId,
              pageTitle: title,
              directory: directory,
              readTime: readTime,
              publishedDate: publishedDate,
              pageType,
              pageUrl: pageUrl,
              thumbnailImage: thumbnailImage,
            }}
            scrapbookContentType={ScrapbookContentType.Article}
            scrapbookPath={`rprt.${pageId}.link.json`}
            successMessage="Report was added to the scrapbook"
            tooltipProps={{ content: 'Save to Scrapbook', placement: 'top' }}
            className="btn icon btn-from-bg transparent [&_svg]:h-7 [&_svg]:w-7"
          />
        )}
      </div>
    </>
  );
};

export default ArticleTools;
